
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotion/[...code]",
      function () {
        return require("private-next-pages/promotion/[...code].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promotion/[...code]"])
      });
    }
  